"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPalette = exports.SharedColors = exports.NeutralColors = exports.CommunicationColors = void 0;
var FluentColors_1 = require("./FluentColors");
Object.defineProperty(exports, "CommunicationColors", { enumerable: true, get: function () { return FluentColors_1.CommunicationColors; } });
Object.defineProperty(exports, "NeutralColors", { enumerable: true, get: function () { return FluentColors_1.NeutralColors; } });
Object.defineProperty(exports, "SharedColors", { enumerable: true, get: function () { return FluentColors_1.SharedColors; } });
var DefaultPalette_1 = require("./DefaultPalette");
Object.defineProperty(exports, "DefaultPalette", { enumerable: true, get: function () { return DefaultPalette_1.DefaultPalette; } });
//# sourceMappingURL=index.js.map